import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

import { DeliveryWindowItem } from '@libs/shared/models';
import { LuxonDatePipe } from '@libs/shared/ui';

@Component({
  selector: 'ui-delivery-windows-form',
  imports: [LuxonDatePipe],
  templateUrl: './delivery-windows-form.component.html',
  styleUrl: './delivery-windows-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryWindowsFormComponent {
  public deliveryWindows: InputSignal<DeliveryWindowItem[]> = input.required();
}
